module.exports = __webpack_public_path__ + "img/companyName.664dd1f6.png";